export default __webpack_public_path__ + "app_store_qr.png";